import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import {
  createScaffolderLayout,
  LayoutTemplate,
} from '@backstage/plugin-scaffolder-react';
import { memo, useEffect } from 'react';
import { isEqual } from 'lodash';
import {
  createFormPersistenceKey,
  persistFormState,
} from './form-state-manager.ts';
import { identityApiRef, useApi } from '@backstage/core-plugin-api';
import { useAsync } from 'react-use';
import Grid from '@material-ui/core/Grid';
import { debounce } from '@material-ui/core';

import { getTemplateRefFromPath } from '../utils.ts';

type PersistenceProps = {
  formData: any;
  schema: Record<string, any>;
};

const debouncedPersistFormState = debounce(
  (k, v) => persistFormState(k, v),
  300,
);

const PersistState = memo(function PersistState(props: PersistenceProps) {
  const { formData, schema } = props;
  const api = useApi(identityApiRef);
  const userAsyncState = useAsync(() => api.getBackstageIdentity(), [api]);

  useEffect(() => {
    const product_name = formData.product_name;
    if (!userAsyncState.value || !product_name) {
      return;
    }

    const templateRef = getTemplateRefFromPath();
    const key = createFormPersistenceKey(
      userAsyncState.value,
      templateRef,
      product_name,
    );
    debouncedPersistFormState(key, formData);
  }, [formData, schema, userAsyncState.value]);
  return null;
}, isEqual);

const PersistFormStateInternal: LayoutTemplate = props => {
  const { properties, formData, idSchema } = props;

  return (
    <Grid container>
      <PersistState formData={formData} schema={idSchema} />
      {properties.map(prop => (
        <Grid item xs={12}>
          {prop.content}
        </Grid>
      ))}
    </Grid>
  );
};

export const PersistFormState = scaffolderPlugin.provide(
  createScaffolderLayout({
    name: 'PersistForm',
    component: PersistFormStateInternal,
  }),
);
